import styled from 'styled-components';

export const WizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  
  @media (min-width: 481px) {
    margin-top: 1.5rem;
  }
`;

export const StepIndicatorWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #edf2f7;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 50;

  @media (max-width: 480px) {
    padding: 0.5rem 0;
    border-bottom: none;
    position: relative;
    top: auto;
  }
`;

export const StepIndicator = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0;
    margin-bottom: 0.5rem;
    width: 100%;
    max-width: 320px;

    &::before {
        content: '';
        position: absolute;
        top: 16px;
        left: 1rem;
        right: 1rem;
        height: 2px;
        background-color: #e2e8f0;
        z-index: 0;
    }
`;

export const StepLine = styled.div<{ active: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 2px;
  background-color: ${props => props.theme.primary || '#e74c3c'};
  z-index: 1;
  transition: width 0.3s ease;
  width: 0;
`;

export const StepItem = styled.div<{ active: boolean; completed: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  z-index: 2;
  position: relative;
`;

export const StepCircle = styled.div<{ active: boolean; completed: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${props => (props.active || props.completed) ? (props.theme.primary || '#e74c3c') : 'white'};
  border: 2px solid ${props => (props.active || props.completed) ? (props.theme.primary || '#e74c3c') : '#e2e8f0'};
  color: ${props => (props.active || props.completed) ? 'white' : '#a0aec0'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  transition: all 0.2s;

  i {
    font-size: 0.8rem;
    color: white !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StepLabel = styled.span<{ active: boolean }>`
  font-size: 0.75rem;
  font-weight: ${props => props.active ? '700' : '500'};
  color: ${props => props.active ? '#2d3748' : '#a0aec0'};
`;

export const CouponCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 1.5rem;

  &:hover {
    border-color: ${props => props.theme.primary || '#e74c3c'};
    background-color: #fffaf0;
  }

  i {
    font-size: 1.5rem;
    color: #a0aec0;
  }
`;

export const CouponCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;

  strong {
    font-size: 0.95rem;
    color: #2d3748;
  }

  span {
    font-size: 0.85rem;
    color: #718096;
  }
`;

export const PaymentOption = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: ${props => props.selected ? 'white' : '#f8fafc'};
  border: 1px solid ${props => props.selected ? (props.theme.primary || '#e74c3c') : '#e2e8f0'};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    border-color: ${props => props.theme.primary || '#e74c3c'};
    background-color: #fff;
  }

  i {
    font-size: 1.25rem;
    color: #4a5568;
    width: 24px;
    text-align: center;
    flex-shrink: 0;
  }

  span {
    font-weight: 600;
    color: #2d3748;
  }

  .check {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${props => props.theme.secondary || props.theme.primary || '#e74c3c'};
    display: flex;
    align-items: center;
    justify-content: center;
    color: white !important;
    font-size: 0.8rem;
    flex-shrink: 0;

    i {
      color: white !important;
      font-size: 0.8rem;
      width: auto;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const PaymentOptionInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const TwoPaymentsButton = styled.button`
  width: 100%;
  padding: 1rem;
  background: none;
  border: none;
  color: ${props => props.theme.secondary || props.theme.primary || '#e74c3c'};
  font-weight: 800;
  font-size: 0.9rem;
  text-transform: uppercase;
  cursor: pointer;
  margin: 1rem 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const SummarySection = styled.div`
  background-color: #f8fafc;
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
  border: 1px solid #edf2f7;
`;

export const AddressSummary = styled.div<{ active?: boolean; clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  border-radius: 12px;
  border: 1px solid ${props => props.active ? (props.theme.primary || '#e74c3c') : '#edf2f7'};
  margin-bottom: 0.75rem;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: all 0.2s;
  position: relative;

  &:hover {
    border-color: ${props => props.theme.primary || '#e74c3c'};
  }

  i {
    color: #a0aec0;
    font-size: 1.2rem;
    width: 24px;
    text-align: center;
  }

  .check {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${props => props.theme.primary || '#e74c3c'};
    display: flex;
    align-items: center;
    justify-content: center;
    color: white !important;
    font-size: 0.8rem;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);

    i {
      color: white !important;
      font-size: 0.8rem;
      width: auto;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .radio {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #e2e8f0;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const AddressDetailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  border-top: 1px dashed #e2e8f0;
  cursor: pointer;

  i {
    color: #a0aec0;
    font-size: 1.2rem;
    width: 24px;
    text-align: center;
  }

  span {
    flex: 1;
    font-size: 0.95rem;
    color: #2d3748;
    font-weight: 600;
  }

  .arrow {
    color: ${props => props.theme.secondary || props.theme.primary || '#e74c3c'};
    font-size: 1.2rem;
  }
`;

export const ClosedMessage = styled.div`
  color: ${props => props.theme.error || '#e53e3e'};
  font-weight: 700;
  font-size: 0.95rem;
  text-align: center;
  margin: 1.5rem 0;
`;

export const ScheduledInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;

  strong {
    font-size: 0.95rem;
    color: #2d3748;
  }

  span {
    font-size: 0.85rem;
    color: #718096;
  }
`;

export const EditButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.secondary };
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const AddressInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;

  strong {
    font-size: 0.95rem;
    color: #2d3748;
  }

  span {
    font-size: 0.85rem;
    color: #718096;
  }
`;

export const ChangeButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.primary || '#e74c3c'};
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const SummaryRow = styled.div<{ total?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.total ? '0' : '0.6rem'};
  font-weight: ${props => props.total ? '800' : '500'};
  font-size: ${props => props.total ? '1.2rem' : '0.95rem'};
  color: ${props => props.total ? '#2d3748' : '#718096'};
  ${props => props.total && `
    border-top: 2px solid #e2e8f0;
    padding-top: 0.8rem;
    margin-top: 0.8rem;
    color: #2d3748;
  `}
  
  span:last-child {
    color: ${props => props.total ? '#2d3748' : '#2d3748'};
    font-weight: 700;
  }
`;


export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const SectionTitle = styled.h4`
  font-size: 1rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 0.5rem 0;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const Label = styled.label`
  font-size: 0.85rem;
  font-weight: 600;
  color: #4a5568;
`;

export const Select = styled.select`
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 0.95rem;
  color: #2d3748;
  background-color: white;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.primary || '#e74c3c'};
    box-shadow: 0 0 0 2px ${props => props.theme.primary ? `${props.theme.primary}1A` : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const TextArea = styled.textarea`
  padding: 0.75rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  font-size: 0.95rem;
  color: #2d3748;
  resize: none;
  height: 80px;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.primary || '#e74c3c'};
    box-shadow: 0 0 0 2px ${props => props.theme.primary ? `${props.theme.primary}1A` : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const CheckoutButton = styled.button`
  width: 100%;
  padding: 1rem;
  background-color: ${props => props.theme.primary || '#e74c3c'};
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px ${props => props.theme.primary ? `${props.theme.primary}33` : 'rgba(0, 0, 0, 0.1)'};
  flex: 1;
  min-width: 0;

  &:hover:not(:disabled) {
    filter: brightness(0.9);
    transform: translateY(-1px);
    box-shadow: 0 6px 12px ${props => props.theme.primary ? `${props.theme.primary}4D` : 'rgba(0, 0, 0, 0.15)'};
  }

  &:disabled {
    background-color: #cbd5e0;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const CashbackBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #f0fff4;
  border: 1px solid #c6f6d5;
  color: #276749;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-top: 1rem;

  i {
    font-size: 1rem;
  }
`;

export const CashbackSection = styled.div`
  background-color: #f0fff4;
  border: 1px solid #c6f6d5;
  border-radius: 12px;
  padding: 1.25rem;
  margin-bottom: 1.5rem;
`;

export const CashbackHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  color: #276749;

  .title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    
    i {
      font-size: 1.25rem;
    }

    strong {
      font-size: 1rem;
    }
  }

  .balance {
    font-size: 0.9rem;
    font-weight: 700;
  }
`;

export const CashbackInputWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
  
  & > input {
    flex: 1;
    padding: 0.6rem;
    border-radius: 8px;
    border: 1px solid #c6f6d5;
    font-size: 0.9rem;
    
    &:focus {
      outline: none;
      border-color: #276749;
    }
  }

  & > div:first-child {
    flex: 1;
    border-color: #c6f6d5;
    padding: 0.4rem 0.75rem;

    input {
      font-size: 1rem;
    }

    &:focus-within {
      border-color: #276749;
      box-shadow: 0 0 0 3px rgba(39, 103, 73, 0.1);
    }
  }
  
  button {
    padding: 0.6rem 1rem;
    background-color: #276749;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 700;
    font-size: 0.85rem;
    cursor: pointer;
    
    &:disabled {
      background-color: #cbd5e0;
      cursor: not-allowed;
    }
  }
`;

export const LoginPrompt = styled.div`
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${props => props.theme.secondary };
    background-color: #f8fafc;
  }

  i {
    background-color: ${props => props.theme.secondary };
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    color: #4a5568;
    line-height: 1.4;

    strong {
      color: #2d3748;
    }
  }
`;

export const CashbackList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PaymentInfo = styled.div`
  margin-top: 0.5rem;
  padding: 0.75rem;
  background-color: #ebf8ff;
  border: 1px solid #bee3f8;
  border-radius: 8px;
  color: #2b6cb0;
  font-size: 0.85rem;
  line-height: 1.4;
`;

export const CashbackItem = styled.div<{ disabled?: boolean; outOfCart?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: white;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  opacity: ${props => props.disabled ? 0.6 : 1};
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);

  .icon-container {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background-color: ${props => props.outOfCart ? '#f0fff4' : '#ebf8ff'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 1.25rem;
      color: ${props => props.outOfCart ? '#38a169' : '#3182ce'};
    }
  }
`;

export const CashbackInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const CashbackName = styled.strong`
  font-weight: 600;
  font-size: 0.95rem;
  color: #2d3748;
`;

export const CashbackDescription = styled.span`
  font-size: 0.8rem;
  color: #a0aec0;
`;

export const CashbackValue = styled.span`
  font-size: 0.85rem;
  color: #a0aec0;
  font-weight: 500;
`;

export const CashbackButton = styled.button<{ secondary?: boolean }>`
  background: none;
  border: none;
  color: ${props => props.disabled ? '#cbd5e0' : (props.secondary ? '#a0aec0' : (props.theme.secondary || props.theme.primary || '#e74c3c'))};
  font-weight: 800;
  font-size: 0.85rem;
  text-transform: uppercase;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  padding: 0.5rem;
  transition: all 0.2s;

  &:hover {
    opacity: ${props => props.disabled ? 1 : 0.7};
  }

  &.add-to-cart {
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.2;
    
    span {
       font-size: 0.75rem;
    }
  }
`;

export const CashbackPrice = styled.div`
  font-size: 0.85rem;
  color: #718096;
  font-weight: 600;
`;

export const CashbackSectionNote = styled.p`
  font-size: 0.85rem;
  color: #a0aec0;
  line-height: 1.4;
  margin: 1.5rem 0 1rem 0;
`;

export const ChangeInfoSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
  border-top: 1px dashed #e2e8f0;
  width: 100%;
`;

export const ChangeText = styled.span`
  font-size: 0.85rem;
  color: #718096;
  font-weight: 500;
`;

export const EditChangeButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.secondary };
  font-weight: 800;
  font-size: 0.85rem;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const PaymentActions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;

export const PaymentActionButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.secondary || props.theme.primary || '#e74c3c'};
  font-weight: 800;
  font-size: 0.85rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  i {
    font-size: 0.8rem;
    color: ${props => props.theme.secondary || props.theme.primary || '#e74c3c'} !important;
  }
`;

export const ConfirmationSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0;
  border-bottom: 1px dashed #e2e8f0;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const OrderItemRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;

  .qty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-weight: 700;
    font-size: 0.9rem;
    color: #2d3748;
  }

  .details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    strong {
      font-size: 0.95rem;
      color: #2d3748;
    }

    span {
      font-size: 0.85rem;
      color: #718096;
    }
  }

  .price {
    font-weight: 700;
    font-size: 0.95rem;
    color: #2d3748;
  }
`;

export const PaymentSummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.75rem;

  i {
    font-size: 1.2rem;
    color: #a0aec0;
    width: 24px;
    text-align: center;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;

    strong {
      font-size: 0.95rem;
      color: #2d3748;
    }

    span {
      font-size: 0.85rem;
      color: #718096;
    }
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0.5rem 0 1rem 0;
`;

export const StatusIcon = styled.div`
  font-size: 4rem;
  color: #27ae60;
  margin-bottom: 1.5rem;
`;

export const StatusHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
  text-align: center;
  width: 100%;
`;

export const StatusBadgeContainer = styled.div<{ status: string }>`
  background-color: ${props => {
    switch (props.status) {
      case 'DELIVERED': return '#f0fff4';
      case 'CANCELLED': return '#fff5f5';
      default: return '#f0fff4';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'DELIVERED': return '#27ae60';
      case 'CANCELLED': return props.theme.error || '#e53e3e';
      default: return '#27ae60';
    }
  }};
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-weight: 800;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

export const StatusTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 900;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.5px;
`;

export const StatusSubtitle = styled.p`
  color: #718096;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
  max-width: 320px;
  font-weight: 500;
`;

export const NewStatusStepper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  margin-bottom: 1.25rem;
  padding-left: 1rem;
`;

export const NewStatusStep = styled.div<{ active: boolean; completed: boolean }>`
  display: flex;
  gap: 1rem;
  position: relative;
  padding-bottom: 1.25rem;

  &:last-child {
    padding-bottom: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 32px;
    bottom: 0;
    width: 2px;
    background-color: ${props => props.completed ? '#27ae60' : '#f1f5f9'};
    display: ${props => props.active && !props.completed ? 'none' : 'block'};
    z-index: 0;
  }

  &:last-child::before {
    display: none;
  }
`;

export const NewStatusCircle = styled.div<{ active: boolean; completed: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${props => props.completed ? '#27ae60' : props.active ? 'white' : '#f1f5f9'};
  border: 2px solid ${props => props.completed ? '#27ae60' : props.active ? (props.theme.primary || '#e74c3c') : '#f1f5f9'};
  color: ${props => props.completed ? 'white' : props.active ? (props.theme.primary || '#e74c3c') : '#cbd5e0'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
  z-index: 1;
  flex-shrink: 0;
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 ${props => props.active ? (props.theme.primary ? `${props.theme.primary}66` : 'rgba(231, 76, 60, 0.4)') : 'rgba(39, 174, 96, 0.4)'};
    }
    70% {
      box-shadow: 0 0 0 10px ${props => props.active ? (props.theme.primary ? `${props.theme.primary}00` : 'rgba(231, 76, 60, 0)') : 'rgba(39, 174, 96, 0)'};
    }
    100% {
      box-shadow: 0 0 0 0 ${props => props.active ? (props.theme.primary ? `${props.theme.primary}00` : 'rgba(231, 76, 60, 0)') : 'rgba(39, 174, 96, 0)'};
    }
  }

  animation: ${props => props.active ? 'pulse 2s infinite' : 'none'};
  transition: all 0.3s ease;
`;

export const StatusHelpSection = styled.div`
  margin-top: 1.5rem;
  padding: 1rem;
  border-top: 1px solid #edf2f7;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StatusHelpTitle = styled.h5`
  font-size: 0.85rem;
  font-weight: 700;
  color: #4a5568;
  margin: 0;
  text-align: left;
`;

export const StatusHelpButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: none;
  border: 1px solid #e2e8f0;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f7fafc;
    border-color: #cbd5e0;
  }

  i {
    color: #25d366;
    font-size: 1.1rem;
  }
`;

export const NewStatusInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: left;
`;

export const NewStatusLabel = styled.span<{ active: boolean }>`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${props => props.active ? '#2d3748' : '#a0aec0'};
`;

export const StatusPrintHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 2rem;
  padding: 0;
`;

export const OrderIdBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;

  span {
    font-size: 0.8rem;
    color: #a0aec0;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  strong {
    font-size: 2.25rem;
    font-weight: 900;
    color: #1a202c;
    margin: 2px 0;
    line-height: 1;
  }
  
  small {
    font-size: 0.9rem;
    color: #718096;
    margin-top: 4px;
    font-weight: 500;
  }
`;

export const DeliveryEstimateBox = styled.div<{ accepted?: boolean }>`
  background-color: ${props => props.accepted ? '#e6ffed' : '#fff5f5'};
  border: 1px solid ${props => props.accepted ? '#c6f6d5' : '#fed7d7'};
  border-radius: 12px;
  padding: 0.85rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 160px;
  text-align: center;

  strong {
    color: ${props => props.accepted ? '#2f855a' : (props.theme.error || '#e53e3e')};
    font-size: 0.8rem;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 2px;
    letter-spacing: 0.5px;
  }

  span {
    color: ${props => props.accepted ? '#276749' : '#c53030'};
    font-size: 1.1rem;
    font-weight: 800;
    line-height: 1.2;
  }
`;

export const OrderHeaderCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0,0,0,0.04);
  margin-bottom: 0.75rem;
`;

export const OrderCodeBadge = styled.span<{ accepted?: boolean }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  font-weight: 900;
  font-size: 1.1rem;
  color: ${props => props.accepted ? '#155724' : '#7b341e'};
  background-color: ${props => props.accepted ? '#d4edda' : '#fff5f5'};
  border: 1px solid ${props => props.accepted ? '#c3e6cb' : '#fed7d7'};
`;

export const ConfirmationCodeContainer = styled.div`
  background-color: #fffaf0;
  border: 2px dashed #f6ad55;
  border-radius: 12px;
  padding: 1.25rem;
  margin: 0.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
`;

export const ConfirmationCodeTitle = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #dd6b20;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ConfirmationCodeValue = styled.span`
  font-size: 2.25rem;
  font-weight: 800;
  color: #2d3748;
  letter-spacing: 0.25em;
  font-family: 'Courier New', Courier, monospace;
`;

export const ConfirmationCodeLabel = styled.p`
  font-size: 0.85rem;
  color: #718096;
  margin: 0;
`;

export const StatusTimelineContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1rem;
  padding-left: 0.5rem;
  position: relative;
`;

export const VerticalTimeline = styled.div<{ progressHeight: string }>`
  position: absolute;
  left: 28px;
  top: 25px;
  bottom: 50px;
  width: 2px;
  background-color: #f1f5f9;
  z-index: 0;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: ${props => props.progressHeight};
    background-color: #27ae60;
    transition: height 0.5s ease;
  }
`;

export const TimelineSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
  padding-left: 3rem;
  overflow: hidden;
`;

export const TimelineStepItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 60px;
  margin-bottom: 0.5rem;
`;

export const StepPoint = styled.div<{ active: boolean; completed: boolean }>`
  position: absolute;
  left: -3rem;
  top: 22px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${props => props.completed ? '#27ae60' : 'white'};
  border: 2px solid ${props => props.completed ? '#27ae60' : '#e2e8f0'};
  z-index: 2;
  box-shadow: 0 0 0 4px white;
  margin-left: 14px;

  ${props => props.active && `
    border-color: #27ae60;
    &::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      background-color: #27ae60;
      border-radius: 50%;
    }
  `}
`;

export const StepTime = styled.strong`
  font-size: 1rem;
  font-weight: 800;
  color: #2d3748;
  margin-bottom: 2px;
`;

export const StepCard = styled.div<{ active?: boolean; completed?: boolean }>`
  background-color: #ffffff;
  border: 1px solid ${props => props.active ? '#27ae60' : '#edf2f7'};
  border-radius: 12px;
  padding: 0.75rem 1rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.3s ease;
  
  ${props => props.active && `
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.1);
    transform: translateX(4px);
    width: calc(100% - 4px);
  `}
`;

export const StepDesc = styled.span`
  font-size: 0.95rem;
  color: #718096;
  font-weight: 500;
`;

export const NewStatusTime = styled.span`
  font-size: 0.85rem;
  color: #718096;
`;

export const OrderDetailCard = styled.div`
  background-color: white;
  border: 1px solid #edf2f7;
  border-radius: 16px;
  padding: 1.25rem;
  width: 100%;
  text-align: left;
  margin-top: 0.75rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const DetailSection = styled.div<{ fullWidth?: boolean }>`
  ${props => props.fullWidth && 'grid-column: 1 / -1;'}
`;

export const DetailTitle = styled.h4`
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  i {
    color: #a0aec0;
    font-size: 0.8rem;
  }
`;

export const DetailContent = styled.div`
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.5;
`;

export const WhatsAppPromptContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  padding: 0.25rem 0 0.5rem;
`;

export const WhatsAppPromptIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #e9f9ef;
  color: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 1.85rem;
  }
`;

export const WhatsAppPromptTitle = styled.h3`
  color: #1f2937;
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.25;
  margin: 0;
`;

export const WhatsAppPromptText = styled.p`
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
  max-width: 340px;
`;

export const WhatsAppPromptActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.5rem;

  button {
    min-height: 46px;
    border-radius: 10px;
    font-size: 0.95rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  > button:last-child {
    background-color: transparent;
    border: 1px solid #e2e8f0;
    color: #64748b;

    &:hover {
      background-color: #f8fafc;
      color: #334155;
    }
  }
`;

export const WhatsAppPromptButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  border: none;
  background-color: #25d366;
  color: white;
  box-shadow: 0 8px 18px rgba(37, 211, 102, 0.24);

  &:hover {
    filter: brightness(0.95);
    transform: translateY(-1px);
  }

  i {
    font-size: 1.1rem;
  }
`;
